/**************************************************************************
Name:         main.js
Description:  Site scripting.
Date Created: 08/26/2015 by Jenna Hart
Modified:     2022-10-05 by Owen Haggerty - Removed unused functions
**************************************************************************/
jQuery.noConflict();

window.onpageshow = function(event) {
	if (event.persisted) {
		// Remove disabled/loading state of submit button on browser back
		jQuery('form.single-click .is-disabled').removeClass('is-disabled').attr('disabled', false);
		jQuery('.add-all-to-cart.has-load.is-loading').removeClass('is-loading');
	}
};

jQuery(document).ready(function(){
	//Load images after page load
	setImages();
	setBackgroundImages();
	
	jQuery('form.single-click').submit(function() {
		/* Disable buttons in a form while waiting for the response */
		jQuery(this).find('input[type="submit"]').each(function() {
			var button = jQuery(this);
			disableButton(button);
		});
	});

	//Add a listener to load mobile or desktop images when the viewport size changes
	jQuery(window).on("orientationchange resize", ()=>{setImages()});

	jQuery('#sg-survey-button').on('click', openSurvey);

	jQuery('.sg-close-button').on('click', closeSurvey);
});

function openMobileNav(){
	/* Opens the mobile navigation window */
	closeAccountSide();	//Close the signin sidebar if it's open
	
	jQuery('#navIcon').toggleClass('open');
	jQuery('.primary').toggleClass('active');

	jQuery('div.pageWrapper, div.layFooter').css('filter', 'blur(4px)');
	jQuery('body').css('overflow', 'hidden');
	jQuery('div.overlay').addClass('active');
}

function closeMobileNav(){
	/* Closes the mobile navigation window */
	jQuery('#navIcon').toggleClass('open');
	jQuery( '.primary' ).toggleClass('active');

	jQuery('.primary .navHeader').css('height', '');
	jQuery('.primary .secondary').removeClass('active');
	jQuery('div.pageWrapper, div.layFooter').css('filter', 'blur(0)');
	jQuery('body').css('overflow', 'visible');
	jQuery( 'div.overlay').removeClass('active');
}

function navHovHandler(evt){
	/* Handles clicks on navigation header elements */
	let helement = jQuery(this);
	let navHeader = helement.parent();
	let hasHov = helement.hasClass('hov');
	let subNav = helement.siblings('.secondary');
	let hasSubNav = subNav.find('a').length > 0;

	if(jQuery(window).width() > 768){	//Handle touchscreens at desktop viewport widths
		if(jQuery('html').hasClass('touch') && !hasHov && hasSubNav){
			//Open this subnav
			evt.preventDefault();
			helement.toggleClass('hov');
			helement.parent().toggleClass('hovParent');
			return false;
		}
		else{	//Allow the default link behavior
			return true;
		}
	}
	//Handle mobile touches on subnav headers
	if(!hasHov && hasSubNav){
		evt.preventDefault();
		//Close any open subnavs
		window.setTimeout(function(){
			jQuery('.primary .navHeader').not(navHeader).removeClass('hovParent').css('height', '');
		}, 300);
		jQuery('.primary .navHeader a').removeClass('hov');
		jQuery('.secondary').removeClass('active');
		//Open this subnav
		helement.toggleClass('hov');
		helement.parent().toggleClass('hovParent').css('height', 'auto');
		subNav.addClass('active');
		return false;
	}
	else if(hasHov){	//The subnav is already open
		evt.preventDefault();
		//Close this subnav
		subNav.removeClass('active');
		helement.removeClass('hov');
		setTimeout(function(){
			helement.parent().removeClass('hovParent').css('height', '');
		}, 300);
	}
	else{	//Allow the default behavior (likely clicking a link)
		return true;
	}
}

function setSelectClass(select) {
	/* Marks a select element as optional and/or updates its font */
	//Mark the select as optional
	let isOptional = select.find('option:selected').hasClass('optional');
	if(isOptional) select.addClass('optional');
	else select.removeClass('optional');

	//Update the select's font
	let selectedOption = jQuery('option:selected', select);
	if(selectedOption.hasClass('placeholder')){
		select.addClass('hasPlaceholder');
	}
	else{
		select.removeClass('hasPlaceholder');
	}
	if(select.hasClass('opt') && select.val().length == 0){
		select.addClass('italic');
	}
	else{
		select.removeClass('italic');
	}
}

jQuery('select').each(function(){
	setSelectClass(jQuery(this));
});
jQuery('select').change(function(){
	setSelectClass(jQuery(this));
});

var setImages = debounce(function(mobileWidth){
	/* Load images after page load */
	jQuery('.image-placeholder').each(function() {
		var image = jQuery(this),
			className = image.attr('data-class') != undefined ? image.attr('data-class') : '',
			src = image.attr('data-src') != undefined ? image.attr('data-src') : '',
			alt = image.attr('data-alt') != undefined ? image.attr('data-alt') : '',
			title = image.attr('data-title') != undefined ? image.attr('data-title') : '',
			mobile = image.attr('data-mobile') != undefined ? image.attr('data-mobile') : 0,
			desktop = image.attr('data-desktop') != undefined ? image.attr('data-desktop') : 1;

		if(mobileWidth == undefined)
			mobileWidth = 768;
 
		if(src.length > 0 && (jQuery(window).width() > mobileWidth || mobile > 0) && (jQuery(window).width() <= mobileWidth || desktop > 0)){
			if (title.length > 0)
				image.replaceWith('<img class="' + className + '" src="' + src + '" alt="' + alt + '" title="' + title + '" />');
			else
				image.replaceWith('<img class="' + className + '" src="' + src + '" alt="' + alt + '" />');
		}
	});
}, 100);

var setBackgroundImages = debounce(function() {
	jQuery('.is-not-loaded').each(function() {
		var el = jQuery(this),
			mobile = el.attr('data-mobile') != undefined ? el.attr('data-mobile') : 0;

		if(jQuery(window).width() > 768 || mobile > 0)
			jQuery(this).removeClass('is-not-loaded').addClass('is-loaded');
	});
}, 100);

var disableButton = function(el) {
	el.addClass('is-disabled').attr('disabled', true);
}

function isIE() {
	var ua = window.navigator.userAgent;
	var msie = ua.indexOf("MSIE ");

	if (msie > 0){	// IE 10 or older
		return true;
	}

	var trident = ua.indexOf("Trident/");
	if (trident > 0){	// IE 11
		return true;
	}

	// Other browser
	return false;
}

function addSearchLogAction(itemID, type, searchType){
	/* Adds a new search action to the logs */
	var dataObject = { method : 'setSearchLogActionAjax' }

	dataObject.itemID = itemID;
	dataObject.type = type;
	dataObject.searchType = searchType;

	jQuery.ajax( {
		type     : 'GET',
		url      : '/cfcs/shopDAO.cfc',
		cache    : false,
		dataType : 'json',
		data     : dataObject
	});
}

var setMobileButton = function() {
	/* Enables or disables the form submit button depending on whether the form is valid */
	var isValid = validateForm();

	if(isValid)
		jQuery('.order-controls-top').find('input[type="submit"]').attr('disabled', false);
	else
		jQuery('.order-controls-top').find('input[type="submit"]').attr('disabled', true);
}

var toggleInput = function(){
	/* Toggles visibility for password inputs */
	var wrapper = jQuery(this).parents('.input-toggle-wrapper'),
		input   = wrapper.find('input'),
		viewEl  = wrapper.find('.input-toggle .view'),
		hideEl  = wrapper.find('.input-toggle .hide'),
		type    = input.attr('type');

	if(type == 'password')
	{
		input.attr('type', 'text');
		viewEl.removeClass('is-active');
		hideEl.addClass('is-active');
	}
	else
	{
		input.attr('type', 'password');
		viewEl.addClass('is-active');
		hideEl.removeClass('is-active');
	}
}

function resizeFieldsets(){
	/* Resizes fieldsets to the maximum height of any other fieldset */
	let fieldsets = jQuery('fieldset').filter(':visible').not('.controls, .ignore-resize');
	let currentTop    = 0;	//The top position of the current row of fieldsets
	let currentHeight = 0;	//The tallest height in the current row of fieldsets
	fieldsets.height('auto');	//Let the fieldsets revert to their preferred height

	for(let i = 0; i < fieldsets.length; i++){
		let thisFieldset = jQuery(fieldsets[i]);
		let thisTop      = resizeFieldsetsPosition(thisFieldset);
		let thisHeight   = thisFieldset.height();
		let thisMargin   = resizeFieldsetsMargin(thisFieldset);

		if(thisTop == currentTop){
			if(thisHeight > currentHeight){
				currentHeight = thisHeight;
				for(let j=i; j >= 0; j--){
					//Resize the earlier fieldsets in the current row
					if(resizeFieldsetsPosition(fieldsets[j]) == thisTop){
						let currentMargin = resizeFieldsetsMargin(fieldsets[j]);
						if(currentMargin)	//Adjust the height if the fieldset has a margin
							jQuery(fieldsets[j]).height(currentHeight - currentMargin);
						else
							jQuery(fieldsets[j]).height(currentHeight);
					}
					else{	//
						j = 0;
					}
				}
			}
			if(thisHeight < currentHeight)	//Resize this fieldset to match the rest of the row
				thisFieldset.height(currentHeight - thisMargin);
		}
		else{	//Move to the next fieldset row
			currentTop = thisTop;
			currentHeight = thisHeight;
		}
	}
}

function resizeFieldsetsPosition(fieldset){
	/* Gets the top offset of the fieldset, excluding the top margin */
	let thisFieldset = jQuery(fieldset);
	let thisMargin = resizeFieldsetsMargin(thisFieldset);
	let thisTop = thisFieldset.offset().top - thisMargin;
	return thisTop;
}

function resizeFieldsetsMargin(fieldset){
	/* Gets a fieldset's top margin's numeric value, or 0 if the value cannot be found */
	//For example, if the top margin was "2px" then this function would return 2
	let thisFieldset = jQuery(fieldset);
	let thisMargin   = 0;
	if(undefined != thisFieldset.css('margin-top')){	//Check that a top margin is defined
		let tempMargin = thisFieldset.css('margin-top').replace(/[^\d.-]/g, '');
		if(tempMargin.length)	//Make sure the margin's value was found
			thisMargin = parseFloat(tempMargin);
	}
	return thisMargin;
}

function getSearchData() {
	/* Parses the data in local storage for the product search */
	var searchType = jQuery('#searchType').val();
	var deptID = jQuery('#did').val();

	jQuery('input[name="globalSearchType"]').val(searchType);
	jQuery('input[name="globalDeptID"]').val(deptID);

	if(searchType == 'new') {
		jQuery('form.globalSearchForm').attr('action', '/search/newproducts/');
		return Array.prototype.slice.call(JSON.parse(localStorage.newProductJSON));
	}
	else if(searchType == 'tpr') {
		jQuery('form.globalSearchForm').attr('action', '/search/temporarypricereductions/');
		return Array.prototype.slice.call(JSON.parse(localStorage.tprProductJSON));
	}
	else {
		jQuery('form.globalSearchForm').attr('action', '/search/fullsearch/');
		return Array.prototype.slice.call(JSON.parse(localStorage.allProductJSON));
	}
}

function openSurvey(){
	jQuery('.sg-survey-container').fadeIn();
}

function closeSurvey(){
	jQuery('.sg-survey-container').fadeOut();
}

/**
* Copyright 2012, Digital Fusion
* Licensed under the MIT license.
* http://teamdf.com/jquery-plugins/license/
*
* @author Sam Sehnert
* @desc A small plugin that checks whether elements are within
*     the user visible viewport of a web browser.
*     only accounts for vertical position, not horizontal.
*/

jQuery.fn.visible = function(partial) {

	var $t            = jQuery(this),
		$w            = jQuery(window),
		viewTop       = $w.scrollTop(),
		viewBottom    = viewTop + $w.height(),
		_top          = $t.offset()?.top,
		_bottom       = _top + $t.height(),
		compareTop    = partial === true ? _bottom : _top,
		compareBottom = partial === true ? _top : _bottom;

return ((compareBottom <= viewBottom) && (compareTop >= viewTop));

};
